<div [ngClass]="{'tm-multi-checkbox':label}" [id]="random_id">
  <mat-label *ngIf="label" class="col-form-label" [ngClass]="{'req':mandatory}"
    [innerHtml]="label | HTMLFormatter |translate">
  </mat-label>
  <div class="design-1" *ngIf="design_pattern ==1">
    <ng-container *ngFor="let option of options;let i = index">
      <span class="checkbox-item" [ngClass]="ng_class" *ngIf="enable_active && option.active">
        <ng-container *ngIf="!option.func">
          <span class="checkbox-label pointer" [ngClass]="{'active':option.option_selected}"
            (click)="option.locked && option.option_selected? '': onSelect(option,i)">
            <i class="fa checkbox-icons "
              [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'],'active-option':option['option_selected'],'inactive-option':!option['option_selected'] }"></i>
            <span class="checkbox-title">
              {{ option[title_property]}}
            </span>

          </span>

        </ng-container>
        <ng-container *ngIf="option.func">
          <div class="checkbox-label">
            <i class="fa checkbox-icons " (click)="option.locked && option.option_selected? '': onSelect(option,i)"
              [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'] }"></i>
            <span class="link checkbox-title" (click)="action(option)">
              {{ option[title_property]}}
            </span>
          </div>

        </ng-container>
      </span>
      <span class="checkbox-item" [ngClass]="ng_class" *ngIf="!enable_active">
        <ng-container *ngIf="!option.func">
          <span class="checkbox-label pointer" [ngClass]="{'active':option.option_selected}"
            (click)="option.locked && option.option_selected? '': onSelect(option,i)">
            <i class="fa checkbox-icons "
              [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'],'active-option':option['option_selected'],'inactive-option':!option['option_selected'] }"></i>
            <span class="checkbox-title">
              {{ option[title_property]}}
            </span>

          </span>

        </ng-container>
        <ng-container *ngIf="option.func">
          <div class="checkbox-label">
            <i class="fa checkbox-icons " (click)="option.locked && option.option_selected? '': onSelect(option,i)"
              [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'] }"></i>
            <span class="link checkbox-title" (click)="action(option)">
              {{ option[title_property]}}
            </span>
          </div>

        </ng-container>
      </span>
    </ng-container>


  </div>
  <ng-container *ngIf="design_pattern ==2">
    <div class="design-2">
      <ng-container *ngFor="let option of options;let i = index">
        <span class="checkbox-item" [ngClass]="ng_class" *ngIf="enable_active && option.active">
          <ng-container *ngIf="!option.func">
            <span class="checkbox-label pointer" [ngClass]="{'active':option.option_selected}"
              (click)="option.locked && option.option_selected? '': onSelect(option,i)">
              <i class="fa checkbox-icons "
                [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'],'active-option':option['option_selected'],'inactive-option':!option['option_selected'] }"></i>
              <span class="checkbox-title">
                {{ option[title_property]}}
              </span>
              <span class="job-number" *ngIf="option.count || option.count==0"> {{option.count}} </span>

            </span>

          </ng-container>
          <ng-container *ngIf="option.func">
            <div class="checkbox-label">
              <i class="fa checkbox-icons " (click)="option.locked && option.option_selected? '': onSelect(option,i)"
                [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'] }"></i>
              <span class="link checkbox-title" (click)="action(option)">
                {{ option[title_property]}}
              </span>
              <span class="job-number" *ngIf="option.count || option.count==0"> {{option.count}} </span>

            </div>

          </ng-container>
        </span>
        <span class="checkbox-item" [ngClass]="ng_class" *ngIf="!enable_active">
          <ng-container *ngIf="!option.func">
            <span class="checkbox-label pointer" [ngClass]="{'active':option.option_selected}"
              (click)="option.locked && option.option_selected? '': onSelect(option,i)">
              <i class="fa checkbox-icons "
                [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'],'active-option':option['option_selected'],'inactive-option':!option['option_selected'] }"></i>
              <span class="checkbox-title">
                {{ option[title_property]}}
              </span>
              <span class="job-number" *ngIf="option.count || option.count==0"> {{option.count}} </span>


            </span>

          </ng-container>
          <ng-container *ngIf="option.func">
            <div class="checkbox-label">
              <i class="fa checkbox-icons " (click)="option.locked && option.option_selected? '': onSelect(option,i)"
                [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'] }"></i>
              <span class="link checkbox-title" (click)="action(option)">
                {{ option[title_property]}}
              </span>
              <span class="job-number" *ngIf="option.count || option.count==0"> {{option.count}} </span>

            </div>

          </ng-container>
        </span>
      </ng-container>


    </div>
  </ng-container>
</div>
